import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LocalStorageKeys } from '../../helpers/constants';
import { PosthogService } from '../../services/posthog.service';
import { HttpService } from '../../services/http-service';
import { ITranslation } from '../../models/translations/translations';
import { Subscription } from 'rxjs';

export type OnboardingChoice = 'upload';

@Component({
  selector: 'app-welcome-onboarding-modal',
  templateUrl: './welcome-onboarding-modal.component.html',
  styleUrls: ['./welcome-onboarding-modal.component.scss']
})
export class WelcomeOnboardingModalComponent implements OnInit, OnDestroy {
  private modalOpenTime: number;
  private translationSubscription: Subscription;

  constructor(
    public dialogRef: MatDialogRef<WelcomeOnboardingModalComponent>,
    private posthog: PosthogService,
    public httpService: HttpService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.modalOpenTime = Date.now();
  }

  get t(): ITranslation {
    return this.httpService.getTransation();
  }

  ngOnInit(): void {
    // Track that onboarding modal was shown
    this.posthog.captureEvent('onboarding_modal_shown', {
      timestamp: new Date().toISOString(),
      modal_type: 'welcome_tutorial'
    });

    // Listen for translation changes (when user logs in and language is detected)
    this.translationSubscription = this.httpService.onTranslationChanged.subscribe((translation) => {
      console.log('[WelcomeOnboardingModal] Translation changed, triggering change detection');
      // Trigger change detection to update the modal text
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  onStartTutorial(): void {
    // Track tutorial started
    this.posthog.captureEvent('onboarding_tutorial_started', {
      choice: 'interactive',
      time_to_decision_ms: Date.now() - this.modalOpenTime,
      timestamp: new Date().toISOString()
    });

    // Set onboarding path as super property for all future events
    this.posthog.setSuperProperty('onboarding_path', 'upload');
    this.posthog.setSuperProperty('onboarding_choice_made_at', new Date().toISOString());

    // Mark as completed in localStorage
    localStorage.setItem(LocalStorageKeys.OnboardingWelcomeCompleted, 'true');

    // Close modal and return 'upload' to start the image-to-pattern tutorial
    this.dialogRef.close('upload');
  }

  onSkip(): void {
    // Track tutorial skipped
    this.posthog.captureEvent('onboarding_tutorial_skipped', {
      time_to_decision_ms: Date.now() - this.modalOpenTime,
      timestamp: new Date().toISOString()
    });

    // Set onboarding path as super property for all future events
    this.posthog.setSuperProperty('onboarding_path', 'skipped');
    this.posthog.setSuperProperty('onboarding_choice_made_at', new Date().toISOString());

    // Mark as completed (so it doesn't show again)
    localStorage.setItem(LocalStorageKeys.OnboardingWelcomeCompleted, 'true');

    // Close modal without starting tutorial
    this.dialogRef.close(null);
  }

}
